import { getProjectBySlug } from '../../../../data/projects';
import { CaseStudyPage } from '../../../../components/caseStudy';

const KlmBoardPage = () => <CaseStudyPage project={getProjectBySlug('klm-board')} />;

export default KlmBoardPage;
